import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgSelectModule } from '@ng-select/ng-select';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { TranslocoRootModule } from 'app/transloco-root.module';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    CoreDirectivesModule, 
    TranslocoRootModule, 
    NgSelectModule, 
    FormsModule
  ],
})
export class TextFieldComponent {
 
  @Output() valueChange = new EventEmitter<string>();
  @ViewChild('textInput') textInput!: ElementRef;

  @Input({required: true}) value: string;
  @Input({required: true}) field: IField;
  @Input() readOnly: boolean = false;
 
  

  focusField() {
    setTimeout(() => this.textInput?.nativeElement.focus(), 0);
  }



  updateTextFieldValue($event: Event): void {
    const inputElement = $event.target as HTMLInputElement;
    const value = inputElement.value;
    this.valueChange.emit(value);
  }
}